<script>
import { BAlert } from 'bootstrap-vue'

export default {
    components: {BAlert},
    props: {
        variant: {
            default: 'light'
        }
    }
}
</script>

<template>
    <b-alert
        :variant="variant"
        show
    >
        <div class="alert-body">
            <slot/>
        </div>
    </b-alert>
</template>
